import React, {  useEffect } from "react";
import { UseDashboarddata } from "../Utils/AllData";
import axios from "axios";
import { Wallet } from "lucide-react";


const DashboardData = () => {
  const { data } = UseDashboarddata();
  const dashboardData = data && data.data.values;

  // const [state, setState] = useState(0);
  useEffect(() => {
    var config = {
      method: "get",
      url: "https://api.currencyfreaks.com/latest?apikey=6ae9cc6527a040d18a58f9fe3a66496f",
      headers: {},
    };

    axios(config)
      .then(function (response) {
        // setState(response.data.rates.INR);
      })
      .catch(function (error) {
        console.log(error);
      });
  }, []);

  const clearMonthlyProfit = () => {
    axios.post("https://server.anshfintech.com/api/admin/clear-monthly-profit").then((res) => {
      console.log(res);
    }
    );
  }

  const checkDate = (dateString) => {
    const [day, month, year] = dateString.split('-');
    const currentDate = new Date();
    const currentMonth = (currentDate.getMonth() + 1).toString().padStart(2, '0');
    const currentYear = currentDate.getFullYear().toString();

    console.log(day)

    if (month !== currentMonth || year !== currentYear) {
      console.log("modified");
      // clear dashboard data and update current month
      clearMonthlyProfit();
    } else {
      console.log("not modified");
    }
  };

  return (
    <div className="w-full bg-gradient-to-tl from-[#FEF35A99]/90 via-[#FFFFFF]/20 to-[#FEF35A99]/10 p-[1px]  rounded-[12px] md:rounded-[26px] shadow-custom-inner backdrop-blur-custom bg-black">
  <div
    className={`flex flex-col justify-center h-full bg-gradient-to-b from-[#000000]/80 from-10% via-[#000000] via-80% to-[#000000] to-20%  rounded-[12px] md:rounded-[26px] shadow-custom-inner-high backdrop-blur-custom bg-black"`}
  >
    <div className="space-y-1 md:space-y-3 px-4 py-3 md:px-10 md:py-4">
      <div
        className={`flex flex-row items-center leading-5 text-lg text-[#FEF35A] font-normal md:text-lg lg:text-lg`}
      >
        <Wallet
          color="#FEF35A"
          className="w-4 h-4 lg:w-5 lg:h-5 mr-2"
        />
        AUM
      </div>
      <div>
        {dashboardData &&
          dashboardData.map((ele, i) => {
            // const item = ele[3].replace("₮", "");
            // const item2 = ele[1].replace("₮", "");
            checkDate(ele[5]);

            return (
              <div
                className={`flex space-x-3 md:space-x-10 mt-4 md:mt-8 xl:mt-4 text-white`}
                key={i}
              >
                {ele[2]}
                {/* {ele[1]} / ₹
                {state && state
                  ? parseInt(
                      parseFloat(item2) * parseFloat(state && state)
                    )
                  : null} */}
              </div>
            );
          })}
      </div>
    </div>

    <div className="bg-gradient-to-b from-[#000000]/10 to-[#000000]/50 pt-4 rounded-b-[12px] md:rounded-b-[26px] space-y-1 md:space-y-3 px-4 py-3 md:px-10 md:py-4">
      <div className="text-[#ffffff]/50 text-lg">Monthly Profit</div>
      {dashboardData &&
        dashboardData.map((ele, i) => {
          const item = ele[3].replace("₮", "");
          // const checkValue = Math.sign(item);

          return (
            <div
              key={i}
              className={
                parseFloat(item) > 0
                  ? `text-[16px] text-[#18b13f] font-semibold font-poppins md:text-[30px] md:leading-[22px] mt-2`
                  : parseFloat(item) < 0
                  ? `text-[16px] text-[#eb323f] font-semibold font-poppins md:text-[30px] md:leading-[22px] mt-2`
                  : `text-[16px] text-[#ffffff]/80 font-semibold font-poppins md:text-[30px] md:leading-[22px] mt-2`
              }
            >
              {ele[3]}
            </div>
          );
        })}
    </div>
  </div>
</div>

  );
};
export default DashboardData;
